import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as userApi from "../../../api/user";

export function useEmployees() {
  return useQuery({
    queryKey: ["employees"],
    queryFn: () => userApi.fetchAll(),
  });
}

export function useUpdateEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => userApi.update(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["employees"] }),
  });
}

export function useCreateEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => userApi.save(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["employees"] }),
  });
}

export function useArchiveEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId) => userApi.archive(null, userId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["employees"] }),
  });
}
